import { render, staticRenderFns } from "./ProgressColumn.vue?vue&type=template&id=284cff82&scoped=true&"
import script from "./ProgressColumn.vue?vue&type=script&lang=ts&"
export * from "./ProgressColumn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284cff82",
  null
  
)

export default component.exports